
<template>
  <div style="position: relative;top: -24px;">
    <iframe ref="gameFrame" src="/demo/0327?actionMode=enable" frameborder="0" style="height: calc(100vh - 50px); width: 100vw; margin-bottom: -0.4rem"></iframe>
    <div
      class="d-flex"
      style="position:fixed; left:0px; bottom:0px; justify-content:center; text-align: center; background: rgb(20,20,20); height: 50px; width:100%; padding-top: 7px;">
      <input
        v-model="queryText"
        @keyup.enter="btnSubmit()"
        type="text"
        style="height: 36px;width: 200px; border: solid 1px rgb(150, 150, 150); padding-left:5px; color: rgb(150,150,150)"
      >
      <span style="width: 30px;"></span>
      <v-btn @click="btnSubmit()">
        送出
      </v-btn>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from 'axios'
import uuid from 'short-uuid'
import _ from 'lodash'
import { STTEvent, TTSMarkEvent } from '@/lib/Assistant'
import * as pbUtil from 'pb-util'

export default {
  data(){
    return {
      // dialogflow session id
      sessionId: null,
      queryHistory: [],
      queryText: '',
      waiting: false,
      gameMounted: false
    }
  },
  computed: {
    queryString(){
      return location.search + '&appbar=hide'
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.$store.commit('appbar/toggle', false)
    })
    this.sessionId = uuid.generate()
    this.$onMessage = this.receiveMessage.bind(this)
    window.addEventListener('message', this.$onMessage, false)
    // this.$nextTick(()=>{
    //   console.log('test enable')
    //   this.$refs.gameFrame.contentWindow.postMessage({
    //     type: 'wordprison',
    //     event: 'dev_frame_setup'
    //   })
    // })
  },
  beforeDestroy(){
    window.removeEventListener('message', this.$onMessage)
  },
  methods: {
    btnSubmit(){
      if(!this.waiting && this.queryText){
        let text = this.queryText
        this.waiting = true
        this.queryText = ''
        this.queryHistory.push(text)
        this.detectIntent(text)
          .then((response)=>{
            let result = null
            if(!response.data.webhookStatus || response.data.webhookStatus.code === 0){
              try{
                let payload = pbUtil.value.decode(response.data.queryResult.webhookPayload.fields.google)
                result = payload.richResponse.items.find((item) => item.htmlResponse).htmlResponse.updatedState
              }catch(e){
                console.log(e)
                throw new Error(`htmlResponse not found`)
              }
            }else{
              throw new Error(`(${response.data.webhookStatus.code})${response.data.webhookStatus.message}`)
            }
            console.log(result)
            return result
          })
          .then((result)=>{
            console.log('postMessage')
            this.$refs.gameFrame.contentWindow.postMessage(new STTEvent(result))
          })
          .catch((e)=>{
            console.error(e)
          })
          .finally(()=>{
            this.waiting = false
          })
      }
    },
    detectIntent(text){
      // return axios.post(`http://localhost:8088/andy-self-test/us-central1/dialogflowProxy`, {
      return axios.post(`https://api.voiss.nctu.me/wordprison/dialogflow`, {
        sessionId: this.sessionId,
        queryInput: {
          text: {
            text,
            languageCode: 'zh-tw'
          }
        },
        queryParams: {
          timeZone: 'Asia/Taipei'
        }
      })
    },
    receiveMessage(event){
      if(event.data){
        let data = event.data
        if(data.type && (data.type.indexOf('webpack') > -1 || data.type === 'GetImmersiveApiLibUrl')){
          return
        }
        if(data.type === 'wordprison'){
          if(data.event === 'game.start'){
            this.gameMounted = true
            console.log('receive', data.event)
          }
        }
      }
      if(event.data && event.data.type){
        console.debug('parent-msg:', event.data.type, event)
      }else{
        console.debug('parent-msg:', event.data, event)
      }
    }
  }
}
</script>

<style>

</style>
